import store from '../stores'


export function getLocaleWordContent(key) {
    const locale = store.getState().navigate.getIn(['language', 'selected'])
    const content = require('../resources/data/content/content.'+locale)["word"]
    return content[key] == null ? key : content[key];
}

export function getLocaleObjContent(key) {
    const locale = store.getState().navigate.getIn(['language', 'selected'])
    const content = require('../resources/data/content/content.'+locale)["object"]
    // console.log(locale)
    // const content = require('resources/data/content/content.en')["object"]
    return content[key]
}

export function getLocaleObject(key) {
    const locale = store.getState().navigate.getIn(['language', 'selected'])
    const content = require('../resources/data/object/object.'+locale)
    // const content = require('resources/data/object/object.en')
    return content[key]
}